export const environment = {

  production: false,
    // apiEndpoint: 'http://localhost:12002/api/'
    apiEndpoint: 'https://crm.financeseva.com/product-manager-server/api/'
};
